
namespace RioERP.Invoices {

    @Serenity.Decorators.registerClass()
    export class InvoiceOrdersDialog extends Serenity.EntityDialog<InvoiceOrdersRow, any> {
        protected getFormKey() { return InvoiceOrdersForm.formKey; }
        protected getIdProperty() { return InvoiceOrdersRow.idProperty; }
        protected getLocalTextPrefix() { return InvoiceOrdersRow.localTextPrefix; }
        protected getService() { return InvoiceOrdersService.baseUrl; }
        protected getDeletePermission() { return InvoiceOrdersRow.deletePermission; }
        protected getInsertPermission() { return InvoiceOrdersRow.insertPermission; }
        protected getUpdatePermission() { return InvoiceOrdersRow.updatePermission; }

        protected form = new InvoiceOrdersForm(this.idPrefix);
        
    }
}

    
